import { Controller } from '@hotwired/stimulus';
import { Offcanvas } from 'bootstrap';

// Connects to data-controller="offcanvas"
export default class extends Controller {
  connect() {
    (new Offcanvas(this.element)).show();
  }
}
